import UpdateRoleDialog from './UpdateRoleDialog';

export default UpdateRoleDialog;